<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox">
        <van-icon
          @click="close"
          class="cross"
          name="cross"
        />
      </div>
      <div class="pdfContent">
        <PDF :urlLink="urlLink" />
      </div>
    </div>
  </div>
</template>

<script>
import PDF from '@/components/PDF/index.vue';

export default {
  name: 'XydPdfAgreement',
  components: {
    PDF,
  },
  props: {
    contract: {
      type: Object,
      default: () => ({}),
    },
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  computed: {
    urlLink() {
      const normalizedValue = `${this.contract.value || ''}`.toLowerCase().replace(/-/g, '_');
      const baseUrl = (process.env.BASE_URL || '/').replace(/\/$/, '');
      return `${baseUrl}/pdf/contract_${normalizedValue}.pdf`;
    },
  },
  methods: {
    close() {
      if (this.hidePopup) {
        this.hidePopup();
      }
    },
  },
};
</script>

<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.pdfContent {
  flex: 1;
  overflow: auto;
}
</style>
